import get from 'lodash/get';

class QuestionsMatrix {
  constructor(questions = []) {
    this.questions = questions;
  }

  matchId(id) {
    return this.questions.find((question) => question.id === id);
  }

  push(question) {
    this.questions.push(question);
  }

  getGroup() {
    return this.questions[0] && this.questions[0].getGroup(); 
  }

  getNext() {
    
    if (!this.poll.getNextTo(this)) {
      return {
        error: 'END',
        isLast: true,
      }
    }

    return {
      nextItem: this.poll.getNextTo(this),
    };
  }

  
  getErrors(values) {
    return this.questions.reduce((reduced, question) => [
      ...reduced,
      ...question.getErrors(values),
    ], []);
  }

  getMatrixTitle() {
    return {
      text: get(this.questions[0], "metadata.settings.group"),
      style: {
        fontSize: get(this.questions[0], "metadata.settings.titleSize"),
        // color: get(this.questions[0],"metadata.settings.color")
      },
    };
  }

  getMatrixDescription() {
    return {
      text: get(this.questions[0], "metadata.settings.description"),
      style: {
        fontSize: get(this.questions[0], "metadata.settings.descriptionSize",get(this.questions[0], "metadata.settings.titleSize")),
        // color: get(this.questions[0],"metadata.settings.color")
      },
    };
  }

  getMatrixScoreType() {
    return get(this,'questions[0].score_type'); 
  }

  getMotives() {
    return get(this,'questions.0.motives'); 
  }

  getMatrixScore(){
    return get(this,'questions[0].settings.score');
  }

  getMatrixScoreLabels(){
    return get(this,'questions[0].settings.score.labels',[]);
  }

  getMatrixOrder(){
   return get(this,'questions[0].settings.score.order','default'); 
  }

  getMatrixVoteFontSize(){
    return get(this,'questions[0].settings.voteFontSize',12); 
  }

  getMatrixTopLayout(){
    return get(this,'questions[0].settings.topLayout');
  }

  hasErrors(values) {
    return this.questions.find((question) => !question.isResponseValid(values)); 
  }

  hasQuestionWithNA() {
    return this.questions.find((question) => question.metadata.settings.allowScoreNA === true);
  }

  isBreaker(){
    return get(this.questions[get(this,'questions',[]).length-1], "metadata.settings.break",false);
  }

  isStepable() {
    return 1;
  }

  getQuestions() {
    return this.questions;
  }
}

export default QuestionsMatrix;
